/**
 * @generated SignedSource<<ce84311697ead255964d496f8b4547ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuestionTitle_question$data = {
  readonly definition: {
    readonly __typename: "CustomField__Checkboxes";
    readonly id: string;
    readonly options: ReadonlyArray<{
      readonly text: string;
      readonly value: string;
    }>;
  } | {
    readonly __typename: "CustomField__Date";
    readonly id: string;
  } | {
    readonly __typename: "CustomField__DateTime";
    readonly id: string;
  } | {
    readonly __typename: "CustomField__Email";
    readonly id: string;
  } | {
    readonly __typename: "CustomField__Link";
    readonly id: string;
  } | {
    readonly __typename: "CustomField__MultipleChoice";
    readonly id: string;
    readonly options: ReadonlyArray<{
      readonly text: string;
      readonly value: string;
    }>;
  } | {
    readonly __typename: "CustomField__Numeric";
    readonly maxValue: number;
    readonly minValue: number;
  } | {
    readonly __typename: "CustomField__PhoneNumber";
    readonly id: string;
  } | {
    readonly __typename: "CustomField__String";
    readonly id: string;
  } | {
    readonly __typename: "CustomField__Time";
    readonly id: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly id: string;
  readonly text: string;
  readonly " $fragmentType": "QuestionTitle_question";
};
export type QuestionTitle_question$key = {
  readonly " $data"?: QuestionTitle_question$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuestionTitle_question">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v2 = [
  (v0/*: any*/)
],
v3 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomField__FieldOption",
    "kind": "LinkedField",
    "name": "options",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      },
      (v1/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuestionTitle_question",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "definition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "CustomField__String",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxValue",
              "storageKey": null
            }
          ],
          "type": "CustomField__Numeric",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v3/*: any*/),
          "type": "CustomField__Checkboxes",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v3/*: any*/),
          "type": "CustomField__MultipleChoice",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "CustomField__Date",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "CustomField__Time",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "CustomField__DateTime",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "CustomField__PhoneNumber",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "CustomField__Email",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "CustomField__Link",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FormQuestion",
  "abstractKey": null
};
})();

(node as any).hash = "467a7bd3cd47de674e7045d7f4c25ea2";

export default node;
